export enum ProfileDetailsType {
  PhoneNumber = 'phone-number',
  Address = 'address',
  Email = 'email',
  Traveller = 'traveller',
  SpecialOccasion = 'special-occasion',
  PaymentCard = 'payment-card',
  DeletePopup = 'delete-popup',
}
